import React, { Fragment, useEffect } from "react";
import NewNavbar from "../../new-components/NewNavbar";
import NewPageHeader from "../../new-components/NewPageHeader";
import NewOverrides from "../../new-components/NewOverrides";
import NewDesignSystem from "../../new-components/NewDesignSystem";
import CheckoutSection from "../../components/CheckoutSection";
import NewFooter from "../../new-components/NewFooter";
import NewMadeWith from "../../new-components/NewMadeWith";
import NewScrollTop from "../../new-components/NewScrollTop";
import { useHistory, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import {
  auth,
  provider_fb,
  provider_google,
  provider_apple,
} from "../Firebase";

const CheckoutPage = ({ cartList, user }) => {
  let history = useHistory();
  if (user.user?.email) {
    return (
      <Fragment>
        <NewNavbar />
        <NewOverrides />
        <NewDesignSystem />

      <NewPageHeader />
        <CheckoutSection cartList={cartList} user={user} />
        <NewFooter />
        <NewMadeWith />
        <NewScrollTop />
      </Fragment>
    );
  }
  return <Redirect to="/login" />;
};
const mapStateToProps = (state) => {
  return {
    cartList: state.cartList.cart,
    symbol: state.data.symbol,
    user: state.user,
  };
};

export default connect(mapStateToProps)(CheckoutPage);
